"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.sort");
var _portContacts = require("@/api/portContacts/portContacts");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'portContacts',
  data: function data() {
    return {
      isCnLang: true,
      form: {
        deptId: ''
      },
      hqID: '',
      hqContact: '',
      contactData: [],
      companyList: []
    };
  },
  computed: {},
  methods: {
    validateNull: _validate.validateNull,
    toSearch: function toSearch() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _portContacts.getPortContacts)(this.form.deptId).then(function (response) {
        if (_this.validateNull(response.data.filter(function (item) {
          return item.officeName === '集运中国总部';
        }))) {
          _this.contactData = response.data;
        } else {
          _this.isCnLang ? response.data.filter(function (item) {
            return item.officeName === '集运中国总部';
          })[0].officeName = _this.$t('portContacts.complaintCenter') : response.data.filter(function (item) {
            return item.officeName === '集运中国总部';
          })[0].officeNameEn = _this.$t('portContacts.complaintCenter');
          _this.contactData = response.data;
        }
      }).finally(function () {
        _this.loading.close();
      });
      (0, _portContacts.getPortContacts)(this.hqID).then(function (response) {
        _this.hqContact = response.data;
      });
    }
  },
  created: function created() {
    var _this2 = this;
    //航运集团的deptId
    var groupId = 'DFB2DC7AB9274EC8A467697183D15357';
    this.isCnLang = this.$i18n.locale === 'zh';
    (0, _portContacts.getAllCompany)(groupId).then(function (response) {
      _this2.companyList = response.data.sort(function (a, b) {
        return a.sort > b.sort ? 1 : -1;
      });
      _this2.hqID = _this2.companyList.filter(function (item) {
        return item.name === '集运中国';
      })[0].deptId;
      _this2.companyList.unshift({
        officeNameEn: 'All Companies',
        officeName: '所有公司',
        deptId: ''
      });
      _this2.isCnLang ? _this2.companyList.filter(function (item) {
        return item.name === '集运中国';
      })[0].officeName = _this2.$t('portContacts.complaintCenter') : _this2.companyList.filter(function (item) {
        return item.name === '集运中国';
      })[0].officeNameEn = _this2.$t('portContacts.complaintCenter');
    });
    if (!this.validateNull(this.$route.query)) {
      this.form.deptId = this.$route.query.deptId;
      this.toSearch();
    } else {
      this.toSearch();
    }
  }
};